import * as u from './urx';
export var recalcSystem = u.system(function () {
    var recalcInProgress = u.statefulStream(false);
    return { recalcInProgress: recalcInProgress };
}, [], { singleton: true });
